/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type LimiterChannelFragment = {
	id: string;
	description: {
		groupName: string;
		constraints: {
			limiter: {
				threshold: { supported: boolean; range: { min: number; max: number; step: number } | null };
			} | null;
		};
		features: { channelConfiguration: { supported: boolean } };
	};
	features: {
		name: { name: string } | null;
		limiter: { enabled: boolean; threshold: number | null } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type LimiterChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { limiter: { enabled: boolean; threshold: number | null } | null }
		| { name: { name: string } | null }
		| {};
};

export type LimiterChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type LimiterChannelQueryOpResult = { node: LimiterChannelFragment | {} };

export type LimiterChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type LimiterChannelSubscriptionOpResult = {
	nodeChanges: LimiterChannelFragment | LimiterChannelUpdateFragment | {};
};

export type LimiterChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type LimiterChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const LimiterChannelFragment = gql`
	fragment LimiterChannelFragment on AudioChannel {
		id
		description {
			groupName
			constraints {
				limiter {
					threshold {
						range {
							min
							max
							step
						}
						supported
					}
				}
			}
			features {
				channelConfiguration {
					supported
				}
			}
		}
		features {
			name {
				name
			}
			limiter {
				enabled
				threshold
			}
			channelConfiguration {
				enabled
			}
		}
	}
`;
export const LimiterChannelUpdateFragment = gql`
	fragment LimiterChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelLimiterChange {
				limiter {
					enabled
					threshold
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const LimiterChannelQueryDocument = gql`
	query LimiterChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...LimiterChannelFragment
		}
	}
	${LimiterChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class LimiterChannelQueryGQL extends Apollo.Query<LimiterChannelQueryOpResult, LimiterChannelQueryVariables> {
	override document = LimiterChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const LimiterChannelSubscriptionDocument = gql`
	subscription LimiterChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...LimiterChannelFragment
			}
			... on AudioChannelChange {
				...LimiterChannelUpdateFragment
			}
		}
	}
	${LimiterChannelFragment}
	${LimiterChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class LimiterChannelSubscriptionGQL extends Apollo.Subscription<
	LimiterChannelSubscriptionOpResult,
	LimiterChannelSubscriptionVariables
> {
	override document = LimiterChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const LimiterChannelMutationDocument = gql`
	mutation LimiterChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class LimiterChannelMutationGQL extends Apollo.Mutation<
	LimiterChannelMutationOpResult,
	LimiterChannelMutationVariables
> {
	override document = LimiterChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
